import _Vue from "vue";

export type TranslationDefinitionType = { [key: string]: string };

export function Distance(Vue: typeof _Vue): void {
    Vue.filter('distance', (distance: number = 0) => {
        if (distance < 1)
            return Math.round(distance * 1000) + ' m';

        return new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            maximumFractionDigits: 2
        }).format(distance) + ' km';
    });
}
